import { AlertOutlined, BugOutlined, FolderOpenOutlined, PlusOutlined, SwapOutlined, ToolOutlined } from '@ant-design/icons';
import { Dropdown, FloatButton, type MenuProps } from 'antd';
import { useNavigate } from 'react-router';

export const FAB_ITEMS = [
  { label: 'New Incident', to: '/incidents/new', icon: <AlertOutlined /> },
  { label: 'New Problem', to: '/problems/new', icon: <BugOutlined /> },
  { label: 'New Change', to: '/changes/new', icon: <SwapOutlined /> },
  { label: 'New Case', to: '/crm/cases/new', icon: <FolderOpenOutlined /> },
  { label: 'New Work Order', to: '/crm/work-orders/new', icon: <ToolOutlined /> },
];

/** Quick-create button: one menu panel opens above the + button (keeps the #fab id and aria-label). */
export function Fab() {
  const navigate = useNavigate();
  const items: MenuProps['items'] = FAB_ITEMS.map((i) => ({ key: i.to, icon: i.icon, label: i.label, onClick: () => navigate(i.to) }));
  return (
    <div id="fab">
      <Dropdown menu={{ items }} trigger={['click']} placement="topRight" arrow>
        <FloatButton type="primary" icon={<PlusOutlined />} aria-label="Quick create" style={{ insetInlineEnd: 24, insetBlockEnd: 24 }} />
      </Dropdown>
    </div>
  );
}
